<div class="loader-container text-danger loader" *ngIf="isLoadRecords">
    <app-common-icon [loadingIcon]="isLoadRecords"></app-common-icon>
</div>
